import { apply as applyGeneric } from './generic'
import type { NetworkParams } from './types'

export const match = (hostname: string): boolean => /(^|\.)fortell\.com$/.test(hostname)
export const compactTracking = true

export const apply = (url: URL, params: NetworkParams): void => {
  applyGeneric(url, params)
  url.searchParams.set('utm_source', 'hearingtracker.com')
}
